const messages = {
	en: {
		translations: {
			signup: {
				title: "Sign up",
				toasts: {
					success: "User created successfully! Please login!",
					fail: "Error creating user. Check the reported data.",
				},
				form: {
					name: "Name",
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Register",
					login: "Already have an account? Log in!",
				},
			},
			login: {
				title: "Login",
				form: {
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Enter",
					loading: "Signing in...",
					register: "Don't have an account? Register!",
				},
			},
			auth: {
				toasts: {
					sessionExpired: "Your session has expired. Please sign in again.",
					sessionReplaced: "Your account was accessed on another computer and this session was closed. If it was not you, change your password.",
					invalidCredentials: "Invalid credentials. Please check your details and try again.",
					accessDenied: "Access denied. Please contact the system administrator.",
					networkError: "Could not reach the server. Check your connection and try again.",
					error: "Unable to sign in. Please try again in a moment.",
				},
			},
			dashboard: {
				charts: {
					perDay: {
						title: "Tickets today: ",
					},
				},
			},
			connections: {
				title: "Connections",
				toasts: {
					deleted: "WhatsApp connection deleted sucessfully!",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? It cannot be reverted.",
					disconnectTitle: "Disconnect",
					disconnectMessage: "Are you sure? You'll need to read QR Code again.",
				},
				buttons: {
					add: "Add WhatsApp",
					disconnect: "Disconnect",
					tryAgain: "Try Again",
					qrcode: "QR CODE",
					newQr: "New QR CODE",
					connecting: "Connectiing",
				},
				toolTips: {
					disconnected: {
						title: "Failed to start WhatsApp session",
						content:
							"Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
					},
					qrcode: {
						title: "Waiting for QR Code read",
						content:
							"Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
					},
					connected: {
						title: "Connection established",
					},
					timeout: {
						title: "Connection with cell phone has been lost",
						content:
							"Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
					},
				},
				table: {
					name: "Name",
					status: "Status",
					lastUpdate: "Last Update",
					default: "Default",
					actions: "Actions",
					session: "Session",
				},
			},
			whatsappModal: {
				title: {
					add: "Add WhatsApp",
					edit: "Edit WhatsApp",
				},
				form: {
					name: "Name",
					default: "Default",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "WhatsApp saved successfully.",
			},
			qrCode: {
				message: "Read QrCode to start the session",
			},
			contacts: {
				title: "Contacts",
				toasts: {
					deleted: "Contact deleted sucessfully!",
				},
				searchPlaceholder: "Search ...",
				confirmationModal: {
					deleteTitle: "Delete",
					importTitlte: "Import contacts",
					deleteMessage:
						"Are you sure you want to delete this contact? All related tickets will be lost.",
					importMessage: "Do you want to import all contacts from the phone?",
				},
				buttons: {
					import: "Import Contacts",
					add: "Add Contact",
				},
				table: {
					name: "Name",
					whatsapp: "WhatsApp",
					email: "Email",
					actions: "Actions",
				},
			},
			contactModal: {
				title: {
					add: "Add contact",
					edit: "Edit contact",
				},
				form: {
					mainInfo: "Contact details",
					extraInfo: "Additional information",
					name: "Name",
					number: "Whatsapp number",
					email: "Email",
					extraName: "Field name",
					extraValue: "Value",
				},
				buttons: {
					addExtraInfo: "Add information",
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Contact saved successfully.",
			},
			queueModal: {
				title: {
					add: "Add queue",
					edit: "Edit queue",
				},
				form: {
					name: "Name",
					color: "Color",
					greetingMessage: "Greeting Message",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
			},
			userModal: {
				title: {
					add: "Add user",
					edit: "Edit user",
				},
				form: {
					name: "Name",
					email: "Email",
					password: "Password",
					profile: "Profile",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "User saved successfully.",
			},
			chat: {
				noTicketMessage: "Select a ticket to start chatting.",
			},
			ticketsManager: {
				buttons: {
					newTicket: "New",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Queues",
			},
			tickets: {
				toasts: {
					deleted: "The ticket you were on has been deleted.",
				},
				notification: {
					message: "Message from",
				},
				tabs: {
					open: { title: "Inbox" },
					closed: { title: "Resolved" },
					search: { title: "Search" },
				},
				search: {
					placeholder: "Search tickets and messages.",
				},
				buttons: {
					showAll: "All",
				},
			},
			transferTicketModal: {
				title: "Transfer Ticket",
				fieldLabel: "Type to search for users",
				noOptions: "No user found with this name",
				buttons: {
					ok: "Transfer",
					cancel: "Cancel",
				},
			},
			ticketsList: {
				pendingHeader: "Queue",
				assignedHeader: "Working on",
				noTicketsTitle: "Nothing here!",
				noTicketsMessage: "No tickets found with this status or search term.",
				buttons: {
					accept: "Accept",
				},
			},
			newTicketModal: {
				title: "Create Ticket",
				fieldLabel: "Type to search for a contact",
				add: "Add",
				buttons: {
					ok: "Save",
					cancel: "Cancel",
				},
			},
			accountMenu: {
				trigger: "Account options",
				admin: "Admin",
				user: "Agent",
				profile: "My profile",
				profileHint: "Name, e-mail and password",
				appearance: "Appearance",
				light: "Light",
				dark: "Dark",
				system: "System",
				sounds: "Sounds",
				volume: "Alert volume",
				mute: "Mute",
				unmute: "Unmute",
				test: "Test",
				tickets: "Tickets",
				chat: "Internal chat",
				suggestion: "Suggest an improvement",
				logout: "Log out",
				logoutTitle: "Log out of Message Express?",
				logoutText: "You stop receiving tickets in this browser and show as offline to your team.",
				cancel: "Cancel",
				online: "Online",
				away: "Away",
				goAway: "Set as away",
				goOnline: "Set as online",
				awayHint: "Your team sees you as away. You still get alerts.",
			},
			mainDrawer: {
				listItems: {
					dashboard: "Dashboard",
					connections: "Connections",
					tickets: "Tickets",
					contacts: "Contacts",
					queues: "Queues",
					administration: "Administration",
					users: "Users",
					settings: "Settings",
				},
				appBar: {
					user: {
						profile: "Profile",
						logout: "Logout",
					},
				},
			},
			notifications: {
				noTickets: "No notifications.",
			},
			queues: {
				title: "Queues",
				table: {
					name: "Name",
					color: "Color",
					greeting: "Greeting message",
					actions: "Actions",
				},
				buttons: {
					add: "Add queue",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
				},
			},
			queueSelect: {
				inputLabel: "Queues",
			},
			users: {
				title: "Users",
				table: {
					name: "Name",
					email: "Email",
					profile: "Profile",
					actions: "Actions",
				},
				buttons: {
					add: "Add user",
				},
				toasts: {
					deleted: "User deleted sucessfully.",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"All user data will be lost. Users' open tickets will be moved to queue.",
				},
			},
			settings: {
				success: "Settings saved successfully.",
				title: "Settings",
				settings: {
					userCreation: {
						name: "User creation",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
				},
			},
			messagesList: {
				header: {
					assignedTo: "Assigned to:",
					buttons: {
						return: "Return",
						resolve: "Resolve",
						reopen: "Reopen",
						accept: "Accept",
					},
				},
			},
			messagesInput: {
				placeholderOpen: "Type a message",
				placeholderClosed: "Reopen or accept this ticket to send a message.",
				signMessage: "Sign",
			},
			contactDrawer: {
				header: "Contact details",
				buttons: {
					edit: "Edit contact",
				},
				extraInfo: "Other information",
			},
			ticketOptionsMenu: {
				delete: "Delete",
				transfer: "Transfer",
				confirmationModal: {
					title: "Delete ticket #",
					titleFrom: "from contact ",
					message: "Attention! All ticket's related messages will be lost.",
				},
				buttons: {
					delete: "Delete",
					cancel: "Cancel",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancel",
				},
			},
			messageOptionsMenu: {
				delete: "Delete",
				reply: "Reply",
				confirmationModal: {
					title: "Delete message?",
					message: "This action cannot be reverted.",
				},
			},
			backendErrors: {
				ERR_COMPANY_INVALID_NAME: "Invalid company name.",
				ERR_EMAIL_ALREADY_EXISTS: "This email is already in use.",
				ERR_INVALID_EMAIL: "Invalid email.",
				ERR_INVALID_PHONE: "Invalid phone number. Include the area code.",
				ERR_PHONE_ALREADY_EXISTS: "This phone number is already registered. Log in or contact support.",
				ERR_PASSWORD_TOO_WEAK:
					"Password must be at least 6 characters long.",
				ERR_INVALID_PLAN: "Invalid plan selected.",
				ERR_COMPANY_DISABLED: "This account is disabled. Please contact support.",
				ERR_CANNOT_DELETE_OWN_COMPANY: "You cannot delete your own company.",
				ERR_COMPANY_HAS_CROSS_REFERENCES: "Deletion blocked: data from another company is linked to this one. Check the deletion report.",
				ERR_TOO_MANY_REQUESTS: "Too many attempts. Please wait a moment and try again.",
				ERR_SUGGESTION_INVALID_FILE: "The screenshot must be an image.",
				ERR_SUGGESTION_FILE_TOO_LARGE: "The screenshot must be at most 5 MB.",
				ERR_CHAT_FILE_TOO_LARGE: "The file must be at most 20 MB.",
				ERR_CHAT_INVALID_FILE: "Invalid file.",
				ERR_CHAT_EMPTY_MESSAGE: "Write a message or attach a file.",
				ERR_CHAT_TICKET_NOT_FOUND: "Ticket not found.",
				ERR_NO_CHAT_FOUND: "Conversation not found.",
				ERR_NO_CHAT_MEDIA_FOUND: "Attachment not found.",
				ERR_SUGGESTION_INVALID_STATUS: "Invalid suggestion status.",
				ERR_NO_SUGGESTION_FOUND: "Suggestion not found.",
				ERR_LICENSE_EXPIRED:
					"Your license has expired. Go to Billing to settle the payment and reactivate the system.",
				ERR_APPOINTMENT_NOT_FOUND: "Appointment not found.",
				ERR_INVALID_APPOINTMENT_STATUS: "Invalid appointment status.",
				ERR_INVALID_APPOINTMENT_STATUS_TRANSITION:
					"This status change is not allowed. Completed, no-show or cancelled appointments cannot be reverted.",
				ERR_SLOT_NOT_AVAILABLE: "This time slot is no longer available.",
				ERR_SERVICE_INVALID_USERS: "One or more selected professionals do not belong to this company.",
				ERR_LOGO_INVALID_TYPE: "Invalid format. Use PNG, JPG or WEBP.",
				ERR_LOGO_TOO_LARGE: "Image too large. Maximum 2 MB.",
				ERR_INVALID_SLUG: "Invalid link. Use 3 to 40 characters: letters, numbers and hyphens.",
				ERR_SLUG_ALREADY_IN_USE: "This link is already used by another company.",
				ERR_TRANSACTION_NOT_FOUND: "Financial entry not found.",
				ERR_INVALID_TRANSACTION_STATUS_TRANSITION:
					"This status change is not allowed. A paid entry cannot revert to pending, and a cancelled entry cannot be reopened.",
				ERR_NO_OTHER_WHATSAPP:
					"There must be at lest one default WhatsApp connection.",
				ERR_NO_DEF_WAPP_FOUND:
					"No default WhatsApp found. Check connections page.",
				ERR_WAPP_NOT_INITIALIZED:
					"This WhatsApp session is not initialized. Check connections page.",
				ERR_WAPP_CHECK_CONTACT:
					"Could not check WhatsApp contact. Check connections page.",
				ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"Could not download media from WhatsApp. Check connections page.",
				ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
				ERR_SENDING_WAPP_MSG:
					"Error sending WhatsApp message. Check connections page.",
				ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
				ERR_OTHER_OPEN_TICKET:
					"There's already an open ticket for this contact.",
				ERR_SESSION_EXPIRED: "Session expired. Please login.",
				ERR_USER_CREATION_DISABLED:
					"User creation was disabled by administrator.",
				ERR_NO_PERMISSION: "You don't have permission to access this resource.",
				ERR_NO_TAG_FOUND: "No tag found with this ID.",
				ERR_NO_CAMPAIGN_FOUND: "Campaign not found.",
				ERR_PLAN_FEATURE_DISABLED: "This feature is not included in your plan.",
				ERR_NO_COMPANY_FOUND: "Company not found.",
				ERR_NO_TAGS_TO_ORDER: "No Kanban tag was sent to be ordered.",
				ERR_INVALID_TAG_ORDER: "The order sent for the Kanban lanes is invalid.",
				ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
				ERR_NO_SETTING_FOUND: "No setting found with this ID.",
				ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
				ERR_INVALID_DATE: "Invalid date.",
				ERR_CONTACT_FIELDS_INVALID: "Invalid field list.",
				ERR_CONTACT_FIELDS_TOO_MANY: "At most 30 fields.",
				ERR_CONTACT_FIELD_NAME_INVALID: "Each field needs a name (up to 100 characters).",
				ERR_CONTACT_FIELD_DUPLICATED: "Two fields have the same name.",
				ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
				ERR_NO_USER_FOUND: "No user found with this ID.",
				ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
				ERR_CREATING_MESSAGE: "Error while creating message on database.",
				ERR_CREATING_TICKET: "Error while creating ticket on database.",
				ERR_FETCH_WAPP_MSG:
					"Error fetching the message in WhtasApp, maybe it is too old.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS:
					"This color is already in use, pick another one.",
				ERR_WAPP_GREETING_REQUIRED:
					"Greeting message is required if there is more than one queue.",
			},
		},
	},
};

export { messages };
